module.exports = __webpack_public_path__ + "img/сhivas-footer-logo-mobile.28d29a26.svg";